var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M32 480h208V272H32zm36-172h136v136H68zM272 32v208h208V32zm172 172H308V68h136zM32 240h208V32H32zM68 68h136v136H68zm204 412h208V272H272zm36-172h136v136H308z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }